/* DEED: maatknoppen op mobiel netjes verdelen, 9 oktober 2026.
   Kolombreedte volgt de langste maat; past niet alles op één rij,
   dan worden de rijen gelijk verdeeld (bijv. 3 + 3 in plaats van 5 + 1). */
(function () {
  var SEL = '.product-alt__option-selector:not(.option-selector--swatch) .product-alt__option-selector_btns';
  var GAP = 6;
  var mq = window.matchMedia('(max-width: 749px)');

  function textWidth(label) {
    var range = document.createRange();
    range.selectNodeContents(label);
    return Math.ceil(range.getBoundingClientRect().width);
  }

  function fit() {
    document.querySelectorAll(SEL).forEach(function (btns) {
      if (!mq.matches) {
        btns.style.removeProperty('grid-template-columns');
        return;
      }
      var labels = btns.querySelectorAll('.product-alt__opt-label');
      var count = labels.length;
      var width = btns.clientWidth;
      if (!count || !width) return;
      var max = 0;
      labels.forEach(function (label) {
        max = Math.max(max, textWidth(label));
      });
      var col = Math.max(44, max + 20);
      var maxCols = Math.max(1, Math.floor((width + GAP) / (col + GAP)));
      var rows = Math.ceil(count / maxCols);
      var cols = Math.ceil(count / rows);
      var value = 'repeat(' + cols + ', minmax(0, 1fr))';
      if (btns.style.gridTemplateColumns !== value) {
        btns.style.gridTemplateColumns = value;
      }
    });
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(fit, 50);
  }

  function init() {
    fit();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
